import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../api/client';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(username, password);
      localStorage.setItem('npz_token', res.data.access_token);
      navigate('/');
    } catch (err) {
      // 429 = locked out after repeated failures (server sends the wait time).
      setError(err.response?.status === 429
        ? (err.response.data?.detail || 'Too many failed attempts. Try again later.')
        : 'Invalid username or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 16,
    }}>
      {/* Logo */}
      <img
        src="/logo.svg"
        alt="NPZ Trade Pro"
        style={{ width: 240, marginBottom: 32, opacity: 0.97 }}
      />

      {/* Card */}
      <div className="card" style={{ width: '100%', maxWidth: 380, padding: '32px 28px' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>
            Welcome back
          </h1>
          <p style={{ color: 'var(--muted)', fontSize: 13 }}>
            Sign in to your trading dashboard
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 600, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Username
            </label>
            <input
              className="input"
              placeholder="Enter username"
              autoComplete="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              style={{ width: '100%' }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 600, marginBottom: 6, display: 'block', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Password
            </label>
            <input
              className="input"
              type="password"
              placeholder="Enter password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{ width: '100%' }}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: 6, padding: '8px 12px', marginBottom: 16,
              color: 'var(--red)', fontSize: 13,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', padding: '10px 0', fontSize: 14, fontWeight: 700 }}
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>

      {/* Footer */}
      <p style={{ marginTop: 24, fontSize: 11, color: 'var(--muted)' }}>
        NPZ Trade Pro · Automated Options Trading
      </p>
    </div>
  );
}
